import * as React from 'react'

import getUrl from 'airship/modules/get-url'
import * as analytics from 'airship/modules/track'
import CardWithSvg, {Props as SvgCardProps} from 'airship/patterns/CardWithSvg'

const MessageType: React.FC<SvgCardProps> = (props) => {
  return (
    <CardWithSvg
      {...props}
      orientation="horizontal"
      onClick={(e) => {
        if (props.onClick) props.onClick(e)
        analytics.track('Composer', 'Click', 'Create Message Type', {
          appKey: getUrl.APP_KEY,
          messageType: props.title.toLowerCase(),
        })
      }}
    />
  )
}

export default MessageType
